import { render, staticRenderFns } from "./DeviceTypesUpdateBox.vue?vue&type=template&id=6114c0c5"
import script from "./DeviceTypesUpdateBox.vue?vue&type=script&lang=js"
export * from "./DeviceTypesUpdateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports